import { Pipe, PipeTransform } from '@angular/core';
import { ActiveMobileBlock } from 'src/app/pages/pharmacies/pharmacies.component';
import { FilterListPharmcies } from '../interfaces/filter-list-pharmcies';

@Pipe({
  name: 'pharmaciesFiltersCount'
})
export class PharmaciesFiltersCountPipe implements PipeTransform {
  transform(
    _: number,
    activeTab: ActiveMobileBlock,
    filterList: Map<string, FilterListPharmcies>,
    isListSearch: boolean,
  ): number {
    let values: FilterListPharmcies[] = [];

    if (isListSearch) {
      values = [...filterList.values()];
    } else {
      values = [...filterList.values()].filter((f) => f.name !== 'fif' && f.name !== 'qs');
    }

    if (activeTab === ActiveMobileBlock.map) {
      if (isListSearch) {
        return values.filter((filter) => (filter.name === 'enf' || filter.name === 'fif') && filter.active).length;
      } else {
        return values.filter((filter) => filter.name === 'enf' && filter.active).length;
      }
    } else {
      return values.filter((filter) => filter.active).length;
    }
  }
}
